import React, {Component} from "react";
import './Projects.css'
import movieAppMobile from '../assets/movieApp.png'
import myBookshelfMobile from '../assets/myBookShelfScreen.png'
import mathGameMobile from '../assets/mathGameScreen.png'
import shalomAGameMobile from '../assets/helloFirstGradeScreen.png'
import myContactMobile from '../assets/myContansScreen.png'
import weatherComposeMobile from '../assets/composeWeatherScreen.png'
import dealsZoneComposeMobile from '../assets/dealsZone.png'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faAndroid} from '@fortawesome/free-brands-svg-icons'
import firebaseImg from '../assets/firebase.png'
import kotlinImg from '../assets/kotlin.svg'
import googleplayImg from '../assets/googleplay.png'
import jetpackCompose from '../assets/jetpack.png'

class Projects extends Component {
    render() {
        return (
            <section className={"Projects"} id={"section4"}>
                <h2 style={{color: "#857a7a"}}>Projects</h2>
                <div className="hr"/>
                <div className="row">
                    <div className="column">
                    <div className="ImageContainer">
                            <a href="https://github.com/veskol1/MovieApp">
                                <div className="ProjectTitle" >Movies App (Compose)</div>
                                <img className="projectImgPhone" src={movieAppMobile}/>
                                <div className="iconsDiv">
                                    <FontAwesomeIcon className="iconStyle" style={{color: "#3ddc84"}} icon={faAndroid}/>
                                    <img className="iconStyle" src={kotlinImg}/>
                                    <img className="iconStyle" src={jetpackCompose}/>
                                </div>
                            </a>
                        </div>
                    <div className="ImageContainer">
                            <a href="https://play.google.com/store/apps/details?id=com.vesko.deals_zone">
                                <div className="ProjectTitle">Deals Zone (Compose)</div>
                                <img className="projectImgPhone" src={dealsZoneComposeMobile}/>
                                <div className="iconsDiv">
                                    <FontAwesomeIcon className="iconStyle" style={{color: "#3ddc84"}} icon={faAndroid}/>
                                    <img className="iconStyle" src={kotlinImg}/>
                                    <img className="iconStyle" src={jetpackCompose}/>
                                </div>
                            </a>
                        </div>
                        <div className="ImageContainer">
                            <a href="https://github.com/veskol1/ComposeTest">
                                <div className="ProjectTitle">Weather project (Compose)</div>
                                <img className="projectImgPhone" src={weatherComposeMobile}/>
                                <div className="iconsDiv">
                                    <FontAwesomeIcon className="iconStyle" style={{color: "#3ddc84"}} icon={faAndroid}/>
                                    <img className="iconStyle" src={kotlinImg}/>
                                    <img className="iconStyle" src={jetpackCompose}/>
                                </div>
                            </a>
                        </div>
                        <div className="ImageContainer">
                            <a href="https://github.com/veskol1/MyContacts">
                                <div className="ProjectTitle">My Contacts (Compose)</div>
                                <img className="projectImgPhone" src={myContactMobile}/>
                                <div className="iconsDiv">
                                    <FontAwesomeIcon className="iconStyle" style={{color: "#3ddc84"}} icon={faAndroid}/>
                                    <img className="iconStyle" src={kotlinImg}/>
                                    <img className="iconStyle" src={jetpackCompose}/>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="column">
                    <div className="ImageContainer">
                            <a href="https://play.google.com/store/apps/details?id=com.vesko.mybooks">
                                <div className="ProjectTitle">My Bookshelf</div>
                                <img className="projectImgPhone" src={myBookshelfMobile}/>
                                <div className="iconsDiv">
                                    <FontAwesomeIcon className="iconStyle" style={{color: "#3ddc84"}} icon={faAndroid}/>
                                    <img className="iconStyle" src={kotlinImg}/>
                                    <img className="iconStyle" src={firebaseImg}/>
                                </div>
                            </a>
                        </div>
                        <div className="ImageContainer">
                            <a href="https://play.google.com/store/apps/details?id=com.vesko.hellofirstgrade">
                                <div className="ProjectTitle">Hello First Grade</div>
                                <img className="projectImgPhone" src={shalomAGameMobile}/>
                                <div className="iconsDiv">
                                    <FontAwesomeIcon className="iconStyle" style={{color: "#3ddc84"}} icon={faAndroid}/>
                                    <img className="iconStyle" src={kotlinImg}/>
                                    <img className="iconStyle" src={googleplayImg}/>
                                </div>
                            </a>
                        </div>
                        <div className="ImageContainer">
                            <a href="https://play.google.com/store/apps/details?id=com.vesko.themathgame">
                                <div className="ProjectTitle">Math game App</div>
                                <img className="projectImgPhone" src={mathGameMobile}/>
                                <div className="iconsDiv">
                                    <FontAwesomeIcon className="iconStyle" style={{color: "#3ddc84"}} icon={faAndroid}/>
                                    <img className="iconStyle" src={kotlinImg}/>
                                    <img className="iconStyle" src={googleplayImg}/>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Projects
